module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_iter-step.js
// module id = ../../../node_modules/core-js/modules/_iter-step.js
// module chunks = 0